export class RegisterModel {
  public firstName: string;
  public lastName: string;
  public email: string;
  public password: string;
  public passwordRepeat: string;

  public signupReason: string;
}
